import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { MIDDLE_MARGIN, LARGE_MARGIN, BIG_MARGIN, colorsPalette, TINY_MARGIN } from '../../theme';
import { Background } from '../../types';

const useStyles = (background) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        paddingTop: MIDDLE_MARGIN,
        paddingBottom: MIDDLE_MARGIN,
        background: theme.palette.secondary.dark,

        [theme.breakpoints.up('sm')]: {
          paddingTop: LARGE_MARGIN,
          paddingBottom: LARGE_MARGIN,
          background:
            background === Background.Dark
              ? theme.palette.secondary.dark
              : theme.palette.secondary.light,
        },
      },
      container: {
        display: 'flex',
        flexDirection: 'column-reverse',
        [theme.breakpoints.up('md')]: {
          alignItems: 'center',
          flexDirection: 'row',
        },
      },
      col: {
        [theme.breakpoints.up('md')]: {
          width: '50%',
          maxWidth: '50%',
          flex: 1,
        },
      },
      rightColumn: {
        flex: 1,
        padding: '0 0 0 16px',
        marginBottom: MIDDLE_MARGIN,
        [theme.breakpoints.up('md')]: {
          padding: 0,
          marginBottom: -56,
        },
        '& .swiper-pagination': {
          [theme.breakpoints.up('lg')]: {
            paddingRight: 'calc(33.33% + 12px)',
          },
        },
        '& .swiper-container': {
          '&::after': {
            content: '""',
            display: 'block',
            position: 'absolute',
            right: 0,
            top: 0,
            height: '100%',
            width: 'calc(13% - 12px)',
            background: 'linear-gradient(-90deg, #1B1925 0%, rgba(27, 25, 37, 0.0001) 100%)',
            zIndex: 2,
            [theme.breakpoints.up('lg')]: {
              width: 'calc(21% - 12px)',
            },
          },
        },
      },
      textWrapper: {
        padding: '0 16px',
        [theme.breakpoints.up('md')]: {
          marginLeft: 'auto',
          padding: `0 ${BIG_MARGIN}px 0 16px`,
          maxWidth: 600,
        },
      },
      header: {
        marginBottom: MIDDLE_MARGIN,
        '& span': {
          color: colorsPalette.violet,
        },
      },
      infoItem: {
        marginBottom: MIDDLE_MARGIN,
        '&:last-child': {
          marginBottom: 0,
        },
      },
      singleCardWrapper: {
        width: '100%',
        padding: '0 16px',
        [theme.breakpoints.up('md')]: {
          maxWidth: 600,
          padding: 0,
        },
      },
    }),
  );

const IMAGE_WIDTH = 32;

export const useInfoItemStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleWrapper: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: TINY_MARGIN,
    },
    icon: {
      width: IMAGE_WIDTH,
      height: IMAGE_WIDTH,
      marginRight: TINY_MARGIN,
    },
    title: {
      marginBottom: 0,
    },
    description: {
      color: colorsPalette.gray,
      [theme.breakpoints.up('md')]: {
        marginLeft: TINY_MARGIN + IMAGE_WIDTH,
      },
    },
  }),
);

export const useSliderCardStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      position: 'relative',
      borderRadius: 10,
    },
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    label: {
      background: colorsPalette.blue,
      position: 'absolute',
      top: 16,
      left: 16,
      padding: '5px 16px',
      borderRadius: 5,
      [theme.breakpoints.up('md')]: {
        top: 24,
        left: 24,
      },
    },
  }),
);

export default useStyles;
